import React from "react";

function Map({ src }) {
  const extractSrc = (input) => {
    const match = input.match?.(/src="([^"]+)"/); // Verifica si es un string con <iframe>
    return match ? match[1] : input; // Si no es un iframe, devuelve input directamente
  };

  const mapSrc = extractSrc(src); // Extraemos la URL si es necesario

  return (
    <div className="h-96">
      <iframe
        width="100%"
        height="95%"
        frameBorder="0"
        marginHeight="0"
        marginWidth="0"
        title="map"
        scrolling="no"
        className="rounded-lg"
        src={mapSrc}
      ></iframe>
    </div>
  );
}

export default Map;
